import { IVisitedOffersProviderProps, VisitedOffersProvider } from '@cian/frontend-visited-offers-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveTab } from '../../selectors/activeTab';
import { selectUser } from '../../selectors';
import { RECS_IN_FAVORITES_FEATURE_FLAG } from '../../constants/config';
import { ETabType } from '../../types/filters';
import { useApplicationContext } from '../../utils/applicationContext';
import { RecommendationsListContainer } from '../RecommendationsListContainer';

interface IRecommendationsContainerProps {
  isV2Experiment?: boolean;
}

export const RecommendationsContainer: React.FC<IRecommendationsContainerProps> = ({ isV2Experiment = false }) => {
  const { config } = useApplicationContext();
  const { isAuthenticated } = useSelector(selectUser);
  const { activeTab } = useSelector(selectActiveTab);

  const isAdvertisementsTab = activeTab !== ETabType.JK && activeTab !== ETabType.SavedSearches;
  const isRecommendationsForUnauthenticatedEnabled =
    isV2Experiment && (config.get<boolean>(RECS_IN_FAVORITES_FEATURE_FLAG) || false);

  const { settings, enabled } = config.get<IVisitedOffersProviderProps>('audience.visitedOffers') || {};

  if ((!isAuthenticated && !isRecommendationsForUnauthenticatedEnabled) || !isAdvertisementsTab) {
    return null;
  }

  return (
    <VisitedOffersProvider settings={settings} enabled={enabled}>
      <RecommendationsListContainer hideRecentlyViewed={isRecommendationsForUnauthenticatedEnabled} />
    </VisitedOffersProvider>
  );
};
